import { FormEvent, useState } from "react";

export type CommentDraft = {
  name: string;
  email: string;
  body: string;
};

type CommentFormProps = {
  onSubmit: (comment: CommentDraft) => void;
};

const initialState: CommentDraft = {
  name: "",
  email: "",
  body: ""
};

export function CommentForm({ onSubmit }: CommentFormProps) {
  const [draft, setDraft] = useState(initialState);
  const [honeypot, setHoneypot] = useState("");
  const [errors, setErrors] = useState<string[]>([]);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const nextErrors: string[] = [];

    if (honeypot) return;
    if (!draft.name.trim()) nextErrors.push("Name is required.");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(draft.email)) nextErrors.push("A valid email is required.");
    if (draft.body.trim().length < 12) nextErrors.push("Comment must be at least 12 characters.");

    setErrors(nextErrors);
    if (nextErrors.length > 0) return;

    onSubmit({
      name: draft.name.trim(),
      email: draft.email.trim(),
      body: draft.body.trim()
    });
    setDraft(initialState);
  }

  return (
    <form className="comment-form" onSubmit={handleSubmit}>
      <div className="honeypot" aria-hidden="true">
        <label htmlFor="comment-website">Website</label>
        <input
          id="comment-website"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          value={honeypot}
          onChange={(event) => setHoneypot(event.target.value)}
        />
      </div>

      {errors.length > 0 ? (
        <div className="form-errors" role="alert">
          {errors.map((error) => (
            <p key={error}>{error}</p>
          ))}
        </div>
      ) : null}

      <div className="form-grid">
        <label>
          Name
          <input
            value={draft.name}
            onChange={(event) => setDraft((current) => ({ ...current, name: event.target.value }))}
            autoComplete="name"
          />
        </label>
        <label>
          Email
          <input
            value={draft.email}
            onChange={(event) => setDraft((current) => ({ ...current, email: event.target.value }))}
            type="email"
            autoComplete="email"
          />
        </label>
      </div>
      <label>
        Comment
        <textarea
          value={draft.body}
          onChange={(event) => setDraft((current) => ({ ...current, body: event.target.value }))}
          rows={5}
        />
      </label>
      <button type="submit">Post comment</button>
    </form>
  );
}
